import { IconHeadset, IconMessageCircle } from "@tabler/icons-react";
import styles from "../subscriptionPayment.module.css";
import Button from "../../../../components/UI/Button/button";

export default function NeedHelpCard({ onContactSupport }) {
  return (
    <div className={styles.helpCard}>
      <div className={styles.helpCardIcon}>
        <IconHeadset size={22} />
      </div>
      <h4>Need help?</h4>
      <p>
        Our support team is here to assist you with billing questions or plan
        changes.
      </p>
      <Button
        variant="secondary"
        fullWidth
        leftIcon={<IconMessageCircle size={15} />}
        onClick={onContactSupport}
      >
        Contact Support
      </Button>
    </div>
  );
}
